import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ImageLayerLegend from '~/components/molecules/Editorial/ImageLayerLegend.vue';
import ParagraphTitle from '~/components/atoms/Editorial/ParagraphTitle.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import Cta from '~/components/atoms/Cta.vue';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
export default {
  name: 'IntroImageCta',
  components: {
    ImageLayerLegend: ImageLayerLegend,
    ParagraphTitle: ParagraphTitle,
    SimpleParagraph: SimpleParagraph,
    Cta: Cta
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    paragraphTitle: function paragraphTitle() {
      return this.payload.primary.paragraph_title || [];
    },
    simpleParagraph: function simpleParagraph() {
      return this.payload.primary.simple_paragraph || [];
    },
    readMore: function readMore() {
      return this.payload.primary.read_more === 'Yes';
    },
    button: function button() {
      return {
        textBtn: this.payload.primary.button_text || '',
        type: this.payload.primary.button_type || 'primary',
        url: this.payload.primary.button_url.url || '',
        tracking: {
          data: {
            event_category: this.payload.primary.button_event_category,
            event_action: this.payload.primary.button_event_action,
            event_label: this.payload.primary.button_event_label
          }
        }
      };
    },
    elements: function elements() {
      var _this = this;

      return this.payload.items.map(function (item) {
        var xsmall = formatPrismicImage(item.image.url, ['w_100']) || EMPTY_PIXEL;
        var small = formatPrismicImage(item.image.url, ['w_375']) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_1440']) || EMPTY_PIXEL;
        var xlarge = formatPrismicImage(item.image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
        return {
          src: large,
          srcset: "".concat(xsmall, " 100w, ").concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w"),
          alt: item.alt,
          ratio: item.ratio,
          layer: _this.typeLayer(item.layer),
          context: item.context,
          reference: item.reference,
          legend: item.legend,
          negativeIcon: _this.negative(item.negative_icon),
          negativeText: _this.negative(item.negative_text),
          tracking: {
            data: {
              event_category: item.event_category,
              event_action: item.event_action,
              event_label: item.event_label
            }
          }
        };
      });
    }
  },
  methods: {
    negative: function negative(arg) {
      return arg === 'black';
    },
    typeLayer: function typeLayer(arg) {
      return arg === 'no';
    }
  }
};